import React from "react";
import "./Developer.css";
function MainCont() {
  return (
    <>
      <section className="content-section">
        <div className="row content-row">
          <div className="col-lg-12">
            <div className="content-head">
              <h1>Welcome</h1>
            </div>
            <div className="content-desc">
              <p>
                Welcome to the most exciting and state-of-the-art platform to
                build your blockchain application on ThunderCore Blockchain. If
                you are an Ethereum developer, developing on ThunderCore should
                be seamless and smooth as ThunderCore is fully Ethereum Virtual
                Machine (EVM) compatible and inherits most of the tools and
                libraries from Ethereum. This page acts as a quick guide into
                the ThunderCore developer platform. You will find links to some
                useful resources and websites to get you to start building
                applications on ThunderCore. Feel free to reach out to us on
                Discord when you need any help!
              </p>
            </div>
            <div className="inner-desc">
              <h2>Developer quick start</h2>
              <p>
                Our blockchain natively supports EVM compatible smart contracts.
                The tools required to develop on ThunderCore includes:
              </p>
              <ul>
                <li>Setup Metamask Wallet or other web wallet</li>
                <li>
                  Deploy your contracts on ThunderCore
                  <ul>
                    <li>Using Remix</li>
                    <li>Using Truffle</li>
                    <li>Using Hardha</li>
                  </ul>
                </li>
                <li>Testnet faucet: https://faucet-testnet.thundercore.com/</li>
                <li>
                  Blockchain Explorers
                  <ul>
                    <li>Mainnet: https://viewblock.io/thundercore</li>
                    <li> Testnet: https://explorer-testnet.thundercore.com/</li>
                  </ul>
                </li>
                <li>
                  The ThunderCore's external protocol is compatible with
                  Ethereum. Your existing code supporting Ethereum has a good
                  chance to work as-is
                </li>
              </ul>
            </div>
            <div className="table-content">
              <table>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>References</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Official Website</td>
                    <td>www.gamingarcade.com</td>
                  </tr>
                  <tr>
                    <td>Block Explorer</td>
                    <td>www.scan/gamingarcade.com/</td>
                  </tr>
                  <tr>
                    <td>JSON-RPC</td>
                    <td>www.mainnet-rpc.gamingarcade.com</td>
                  </tr>
                  <tr>
                    <td>Chain ID</td>
                    <td>thunder-mainnet: 108 (0x6c)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="footer-desc">
              <h3>How do I get a ThunderCore address?</h3>
              <p>
                ThunderCore is Ethereum (EVM) compatible. Any address created
                for Ethereum will work on ThunderCore. You can use MetaMask
                and/or any other popular Ethereum wallet to create ThunderCore
                address. To access the ThunderCore blockchain all you will need
                to do is to point network RPC to one of the following:
              </p>
            </div>
            <div className="footer-bottom">
              <div className="footer-bottom-text">
                <p>Next</p>
                <h6>Wallets</h6>
              </div>
              <div className="footer-bottom-image">
                <img src={require("../../Assets/img/foot-arrow.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default MainCont;
